<template>
    <div class="paopaotui-radio">
        <input :type="PType" class="radio" ref="radio" :name="name" @change="onChange">
        <span v-if="PType === 'radio'" class="radio-look"></span>
        <span v-else class="checkbox-look"></span>
    </div>
</template>

<script>
    export default {
        name: 'PRadioButton',
        props: {
            name: {
                default: '',
                required: true,
            },
            value: {
                default: '',
                required: true,
            },
            checked: {
                default: '',
            },
            PType: {
                default: 'radio',
            }
        },
        model: {
            prop: 'checked',
            event: 'input',
        },
        mounted() {
            if (this.value == this.checked) {
                this.$refs.radio.click();
            }
        },
        methods: {
            onChange() {
                if (this.$refs.radio.checked) {
                    this.$emit('input', this.value);
                } else {
                    this.$emit('input', 0);
                }
            }
        },
        watch: {
            checked() {
                if (this.value == this.checked) {
                    this.$refs.radio.checked = true;
                } else {
                    this.$refs.radio.checked = false;
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .paopaotui-radio {
        position: relative;
    }

    .radio {
        opacity: 0;
        position: absolute;
        left: 4px;
        top: 4px;
        margin: 0;
        z-index: 2;
    }

    .radio-look {
        min-width: 18px;
        min-height: 18px;
        display: inline-block;
        vertical-align: middle;
        border: 1px solid rgba(221,221,221,1);
        border-radius: 50%;
        position: relative;
        box-sizing: border-box;
    }

    .radio-look:after {
        content: "";
        position: absolute;
        left: 3px;
        top: 3px;
        bottom: 3px;
        right: 3px;
        border: 1px solid transparent;
        border-radius: 50%;
    }

    .radio:checked + .radio-look:after {
        border: 1px solid rgba(51,153,51,1);
        background-color: rgba(51,153,51,1);
    }

    .checkbox-look {
        min-width: 18px;
        min-height: 18px;
        display: inline-block;
        vertical-align: middle;
        border: 1px solid rgba(221,221,221,1);
        border-radius: 50%;
        position: relative;
        box-sizing: border-box;
    }

    .checkbox-look:after {
        content: "";
        position: absolute;
        left: 5px;
        top: 2px;
        bottom: 4px;
        right: 3px;
        width: 4px;
        height: 6px;
        border: 1px solid transparent;
        transform: rotate(45deg);
    }

    .radio:checked + .checkbox-look {
        background-color: #339933;
    }

    .radio:checked + .checkbox-look:after {
        border-bottom: 1px solid #fff;
        border-right: 1px solid #fff;
    }
</style>
